<fa-icon [icon]="icons[_icon]"></fa-icon>
